import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AlertsListComponent } from './alerts-list/alerts-list.component';
import { ProjectMiscModule } from 'projects/app-misc/src/app/modules/project-misc/project-misc.module';
import { ProjectAlertComponent } from './alerts-list/project-alert/project-alert.component';

@NgModule({
    declarations: [
        AlertsListComponent,
        ProjectAlertComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        MatButtonModule,
        MatRippleModule,
        MatIconModule,
        MatFormFieldModule,
        // ProjectMiscModule
    ],
    exports: [
        AlertsListComponent,
        ProjectAlertComponent
    ],
    entryComponents: []
})
export class SystemAlertsModule { }
